// @flow

import * as React from 'react';

import Star from '!!svg-react-loader!../../../../assets/images/pages/pizza/fields/star.svg';

export class Stars extends React.PureComponent<{ satisfactionScore: number }> {
  render() {
    const score = this.props.satisfactionScore + 5;
    const full = Math.floor(score / 2);
    const half = score % 2;
    const empty = 5 - full - half;
    let stars = [];
    for (let i = 0; i < full; i++) {
      stars.push(<Star key={`full-${i}`} className="star full" />);
    }
    if (half > 0) {
      stars.push(<Star key={`half`} className="star half" />);
    }
    for (let i = 0; i < empty; i++) {
      stars.push(<Star key={`empty-${i}`} className="star empty" />);
    }

    return <span>{stars}</span>;
  }
}
